import React from "react";

/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Resources
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 11Nov2021 craig File created.
 \******************************************************************************/

export const Resources: React.FC = (props) => {

    return (
        <h1>Resources</h1>
    );

}